import React, { useEffect, useState } from "react";
import { Card } from "./TvBits";

export const TvNewsroom = ({ d }) => {
  const stories = [...(d.world || []).filter((w) => w.image), ...(d.headlines || []).filter((h) => h.image)];
  const [i, setI] = useState(0);
  useEffect(() => { const t = setInterval(() => setI((x) => x + 1), 12000); return () => clearInterval(t); }, []);
  if (!stories.length) return <Card title="NEWSROOM"><p className="text-2xl text-cyan-100/40">Loading headlines…</p></Card>;
  const s = stories[i % stories.length];
  const next = [1, 2, 3, 4].map((k) => stories[(i + k) % stories.length]);
  return (
    <div className="grid grid-cols-3 gap-5 h-full" data-testid="tv-scene-newsroom">
      <div key={s.title} className="col-span-2 relative rounded-3xl overflow-hidden nx-fade-up" data-testid="tv-news-hero">
        <img src={s.image} alt="" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#030712] via-[#030712]/70 to-transparent" />
        <div className="absolute left-0 right-0 bottom-0 p-8">
          <span className="inline-block bg-rose-600 text-white nx-orbitron font-black tracking-widest text-lg px-4 py-1 rounded-md mb-4">{s.place ? s.place.toUpperCase() : (s.source || "LIVE").toUpperCase()}</span>
          <p className="text-[clamp(1.5rem,2.8vw,3rem)] font-black leading-tight text-white line-clamp-3">{s.title}</p>
          {(s.summary || s.content) && <p className="text-2xl text-cyan-50/80 mt-4 line-clamp-2">{s.summary || s.content}</p>}
        </div>
      </div>
      <Card title="UP NEXT" accent="#F43F5E" testid="tv-news-next">
        <div className="space-y-6">
          {next.map((n, k) => <p key={k} className="text-[clamp(1rem,1.3vw,1.5rem)] font-semibold leading-snug text-cyan-50 line-clamp-3 border-l-4 border-rose-500/60 pl-4">{n.title}</p>)}
        </div>
      </Card>
    </div>
  );
};
